import { ConstraintScenarionSimulationModel } from './IndicatorScenarioSimulation';

export type IndicatorModel = {
	id: string;
	name: string;
	description: string;
	weight: number;
	trend: string;
	reference: string;
	evaluatedAt: Date;
	frequency?: string;
	enabled: boolean;
	scenarios: ConstraintScenarionSimulationModel[];
};

export const defaults = {
	__typename: 'Indicator',
	name: '',
	description: '',
	weight: 1,
	trend: '50',
	reference: '',
	evaluatedAt: '',
	scenarios: [],
	enabled: true
};
